import { useAuth } from "@/context/AuthContext";
import { pieceSpecs } from "@/lib/design";
import { money } from "@/lib/pricing";

// Per-piece spec list of a designed line; Admin sees the cost breakdown, managers the sell breakdown, reps neither.
export function DesignSpecs({ row, idx }) {
  const { user } = useAuth();
  const parts = user?.role === "owner" ? row.component?.breakdown : row.design_parts;
  return (
    <div className="space-y-2 rounded-[12px] bg-white p-3 text-[13px]" data-testid={`quote-item-design-specs-${idx}`}>
      {pieceSpecs(row.design).map((pc, i) => (
        <div key={i} data-testid={`quote-item-piece-${idx}-${i}`}>
          <p className="font-semibold text-black">{pc.name} {pc.size}{pc.top !== "Rectangle" ? ` · ${pc.top} top` : ""}</p>
          {pc.sections.map((s, j) => <p key={j} className="text-[#3C3C43]">{s}</p>)}
        </div>
      ))}
      {parts?.length > 0 && (
        <details data-testid={`quote-item-design-breakdown-${idx}`}>
          <summary className="cursor-pointer font-medium text-[#0062CC]">{user?.role === "owner" ? "Cost by piece" : "Price by piece"}</summary>
          {parts.map((p, i) => (
            <div key={i} className={`flex justify-between gap-3 py-0.5 ${p.missing ? "text-[#8A4B00]" : "text-[#3C3C43]"}`}>
              <span>{p.label}</span><span className="font-mono-num">{money(p.amount)}</span>
            </div>
          ))}
        </details>
      )}
    </div>
  );
}
